<nav class="navbar bg-light-gradient dark:bg-dark-gradient">
    <button (click)="toggleSidebar()" [class.open]="isSidebarOpen" class="burger-button">
        <div class="bar bar-1"></div>
        <div class="bar bar-2"></div>
        <div class="bar bar-3"></div>
    </button>
    <div class="user-info-container">
        <span *ngIf="plan?.subscription_plan?.isFreeTrial" class="self-center text-sm text-[#289DD2]">
            {{ getDaysLeft() + ' days left in free trial!' }} <span (click)="upgradePlan()"
                class="cursor-pointer font-bold"> Upgrade</span>
        </span>
        <span *ngIf="plan != null"
            class="self-center text-base text-[#289DD2] border-2 border-[#289DD2] px-3 rounded-full cursor-pointer"  (click)="upgradePlan()">
            {{ plan?.subscription_plan?.name }}
        </span>

        <span *ngIf="plan == null" (click)="upgradePlan()"
            class="self-center text-base text-[#289DD2] border-2 border-[#289DD2] px-3 rounded-full cursor-pointer">
            Subscribe
        </span>

        <!-- TODO: can you create a chat bubble at the bottom right that opens on this? (low priority) -->
        <!-- <button class="help">
            <p>Help</p>
            <i class="fa-solid fa-headset"></i>
        </button> -->
        <div class="group relative" id="profile-dropdown">
            <button class="user-info" (click)="toggleDropdown()">
                <div>{{username}}</div>
                <i class="fa-regular fa-user"></i>
            </button>
            <!-- Dropdown Menu -->
            <!-- Dropdown Menu (Visible on hover) -->

            <div *ngIf="isDropdownOpen"
                class="absolute bg-black text-white border border-gray-700 rounded shadow-lg mt-2 right-0 top-14 transition-opacity duration-300 min-w-[14rem] max-w-sm overflow-hidden">


                <div class="flex flex-col items-start p-4 space-y-1">
                    <p class="font-medium text-gray-200 truncate w-full">{{ user.name }}</p>
                    <p class="text-sm text-gray-400 truncate w-full">{{ user.email}}</p>
                    <p class="text-sm text-gray-400 truncate w-full">{{ user.mobile_no }}</p>
                </div>
                <div class="border-t border-gray-700"></div>
                <button
                    class="logout-button flex items-center justify-center w-full p-3 hover:bg-gray-700 transition-colors duration-300"
                    (click)="logout()">
                    <i class="fa-solid fa-power-off mr-2"></i>
                    <p>Logout</p>
                </button>
            </div>


        </div>
    </div>
</nav>
